module.exports = __webpack_public_path__ + "img/Halle_Leer 032.7bf67591.jpg";